import React from "react";
import { renderWithRoot } from "../common/react-root-helper";
import { getState, subscribe } from "../store";
import appActions from "../actions/app";
import App from "../common/app";
import InvoicesComponent from "./components/index";
import { getMyInvoices } from "./actions";
import { getDealers } from "../dealers/actions";

function render(mountNode) {
  return function () {
    renderWithRoot(
      <App active="invoices" {...getState()} {...appActions}>
        <InvoicesComponent {...getState()} {...appActions} />
      </App>,
      mountNode
    );
  };
}

let unsubscribe = function () {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (app, mountNode) {
  app("/invoices", (context) => {
    unsubscribe = subscribe(render(mountNode));
    if (getState().session.id) {
      getMyInvoices();
      // Load dealers for admin users
      const session = getState().session;
      if (session.user && session.user.roles && session.user.roles.some(role => ['DataProvider', 'Administrator', 'Sales'].includes(role))) {
        getDealers();
      }
    }

    render(mountNode)();
  });

  app.exit("/invoices", (context, next) => {
    unsubscribe();
    next();
  });
}
